<template>
	<header
		class="site-header"
		ref="header"
	>
		<nav class="menu">
			<div class="inner">
				<a
					class="logo"
					href="/"
				><img
						v-if="window.width > 1280"
						:src="logo"
						alt="CPMEC"
					/><img
						v-else
						:src="desktopLogo"
						alt="CPMEC"
					/></a>
				<!-- <ul v-if="window.width > 1280">
					<li
						v-for="(menu_item, index) in menu"
						:key="index"
						:class="{
							'has-children':
								menu_item.children && menu_item.children.length > 0,
							selected: menu_item.object_id == currentId,
						}"
					>
						<a
							:href="localUrlSwap(menu_item['url'])"
							v-html="menu_item['title']"
						></a>
					</li>

					<site-button
						v-if="call_to_action_link"
						:link="JSON.parse(call_to_action_link)"
						:label="call_to_action_label"
						:colour="call_to_action_colour"
						:border="call_to_action_border"
						:minHeight="call_to_action_min_height"
						:borderThickness="call_to_action_border_thickness"
						:type="'primary'"
					></site-button>
				</ul> -->

				<ul v-if="window.width > 1280">
					<template v-for="(menu_item, index) in menu">
						<menu-item
							:key="index"
							:menu_item="menu_item"
							:has-children="menu_item.children ? true : false"
							:selected="menu_item.object_id == currentId"
						></menu-item>
					</template>

					<site-button
						v-if="call_to_action_link"
						:link="JSON.parse(call_to_action_link)"
						:label="call_to_action_label"
						:colour="call_to_action_colour"
						:border="call_to_action_border"
						:minHeight="call_to_action_min_height"
						:borderThickness="call_to_action_border_thickness"
						:type="'primary'"
					></site-button>
				</ul>

				<div class="hamburger">
					<site-button
						v-if="
              call_to_action_link && window.width <= 1280 && window.width >= 600
            "
						:link="JSON.parse(call_to_action_link)"
						:label="call_to_action_label"
						:colour="call_to_action_colour"
						:border="call_to_action_border"
						:minHeight="call_to_action_min_height"
						:borderThickness="call_to_action_border_thickness"
						:type="'primary'"
					></site-button>

					<svg
						viewBox="0 0 512 512"
						@click="mobileMenu = true"
						v-if="window.width <= 1280"
					>
						<defs />
						<g data-name="1">
							<path d="M441.13 166.52h-372a15 15 0 110-30h372a15 15 0 010 30zM441.13 279.72h-372a15 15 0 110-30h372a15 15 0 010 30zM441.13 392.92h-372a15 15 0 110-30h372a15 15 0 010 30z" />
						</g>
					</svg>
				</div>
			</div>
		</nav>

		<transition name="bounce">
			<nav
				class="menu scrolled"
				v-if="isScrolled"
			>
				<div class="inner">
					<a
						class="logo"
						href="/"
					><img
							v-if="window.width > 1280"
							:src="scrollLogo"
							alt="CPMEC"
						/><img
							v-else
							:src="mobileLogo"
							alt="CPMEC"
						/></a>
					<ul v-if="window.width > 1280">
						<template v-for="(menu_item, index) in menu">
						<menu-item-scrolled
							:key="index"
							:menu_item="menu_item"
							:has-children="menu_item.children ? true : false"
							:selected="menu_item.object_id == currentId"
						></menu-item-scrolled>
					</template>
						<site-button
							v-if="call_to_action_link"
							:link="JSON.parse(call_to_action_link)"
							:label="call_to_action_label"
							:colour="call_to_action_colour"
							:border="call_to_action_border"
							:minHeight="call_to_action_min_height"
							:borderThickness="call_to_action_border_thickness"
							:type="'primary'"
						></site-button>
					</ul>

					<div class="hamburger">
						<site-button
							v-if="
                call_to_action_link &&
                  window.width <= 1280 &&
                  window.width >= 400
              "
							:link="JSON.parse(call_to_action_link)"
							:label="call_to_action_label"
							:colour="call_to_action_colour"
							:border="call_to_action_border"
							:minHeight="call_to_action_min_height"
							:borderThickness="call_to_action_border_thickness"
							:type="'primary'"
						></site-button>

						<svg
							viewBox="0 0 512 512"
							@click="mobileMenu = true"
							v-if="window.width <= 1280"
						>
							<defs />
							<g data-name="1">
								<path d="M441.13 166.52h-372a15 15 0 110-30h372a15 15 0 010 30zM441.13 279.72h-372a15 15 0 110-30h372a15 15 0 010 30zM441.13 392.92h-372a15 15 0 110-30h372a15 15 0 010 30z" />
							</g>
						</svg>
					</div>
				</div>
			</nav>
		</transition>

		<transition name="mobile-menu">
			<nav
				v-if="mobileMenu === true && window.width <= 1280"
				class="mobile-menu"
			>
				<div class="close">
					<svg
						@click="mobileMenu = false"
						viewBox="0 0 32 32"
						xmlns="http://www.w3.org/2000/svg"
					>
						<title />
						<g id="cross">
							<line
								class="cls-1"
								x1="7"
								x2="25"
								y1="7"
								y2="25"
							/>
							<line
								class="cls-1"
								x1="7"
								x2="25"
								y1="25"
								y2="7"
							/>
						</g>
					</svg>
				</div>

				<div class="inner">
					<span class="seg">
						<a
							class="logo"
							href="/"
						><img
								:src="altLogo"
								alt="CPMEC"
							/></a>

						<ul>
							<!-- <li
								v-for="(menu_item, index) in menu"
								:key="index"
								:class="{
                  'has-children':
                    menu_item.children && menu_item.children.length > 0,
                  selected: menu_item.object_id == currentId,
                }"
							>
								<a
									:href="localUrlSwap(menu_item['url'])"
									v-html="menu_item['title']"
								></a>
							</li> -->

							<template v-for="(menu_item, index) in menu">
								<menu-item-mob
									:key="index"
									:menu_item="menu_item"
									:has-children="menu_item.children ? true : false"
									:selected="menu_item.object_id == currentId"
								></menu-item-mob>
							</template>

							<site-button
								v-if="call_to_action_link"
								:link="JSON.parse(call_to_action_link)"
								:label="call_to_action_label"
								:colour="call_to_action_colour"
								:border="call_to_action_border"
								:minHeight="call_to_action_min_height"
								:borderThickness="call_to_action_border_thickness"
								:type="'primary'"
							></site-button>
						</ul>
					</span>

					<span class="seg">
						<ul class="footer-menu">
							<li
								v-for="(menu_item, index) in footerMenu"
								:key="index"
								:class="{
                  'has-children':
                    menu_item.children && menu_item.children.length > 0,
                  selected: menu_item.object_id == currentId,
                }"
							>
								<a
									:href="localUrlSwap(menu_item['url'])"
									v-html="menu_item['title']"
								></a>
							</li>
						</ul>

						<ul class="social">
							<li>
								<a
									:href="JSON.parse(facebook).url"
									:target="JSON.parse(facebook).target"
								><img
										:src="this.faceIcon"
										alt="Facebook"
									/></a>
							</li>
							<li>
								<a
									:href="JSON.parse(instagram).url"
									:target="JSON.parse(instagram).url"
								><img
										:src="this.instaIcon"
										alt="Instagram"
									/></a>
							</li>
						</ul>
					</span>
				</div>
			</nav>
		</transition>

		<!-- <transition name="slide-fade">
			<div v-if="!isScrolled" class="notification">
				<div class="inner">
					<span> Public Holiday Trading Hours </span>
				</div>
			</div>
		</transition> -->
	</header>
</template>

<script>
import axios from 'axios';
import MenuItem from '../vue/MenuItem.vue';
import MenuItemScrolled from '../vue/MenuItemScrolled.vue';
import MenuItemMob from '../vue/MenuItemMob.vue';
import instagramIcon from '../../images/instagram.svg';
import facebookIcon from '../../images/facebook.svg';
import SiteButton from '../vue/SiteButton.vue';
import ScrollLogo from '../../images/logo-reverse-full.svg';
import MobileLogo from '../../images/logo-reverse.svg';
import DesktopLogo from '../../images/logo.svg';

export default {
  data() {
    return {
      menu: null,
      footerMenu: null,
      mobileMenu: false,
      topScrollThreshold: 100,
      isScrolled: false,
      window: {
        width: 0,
        height: 0,
      },
      instaIcon: instagramIcon,
      faceIcon: facebookIcon,
      mobileLogo: MobileLogo,
      scrollLogo: ScrollLogo,
      desktopLogo: DesktopLogo,
    };
  },

  props: {
    logo: {},
    altLogo: {},
    currentId: {
      type: Number,
      default: -1,
    },
    facebook: {
      default: null,
    },
    instagram: {
      default: null,
    },
    call_to_action_link: {},
    call_to_action_colour: {},
    call_to_action_label: {},
    call_to_action_border: {},
    call_to_action_min_height: {},
    call_to_action_border_thickness: {},
  },

  computed: {},

  watch: {},

  methods: {
    didScroll() {
      var elementTarget = document.querySelector('.site-header');
      this.isScrolled = window.scrollY > elementTarget.offsetHeight + 150;
    },

    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },

    localUrlSwap(value) {
      if (window.location.host === 'localhost:3000') {
        return value.replace('cpmec.test', 'localhost:3000');
      } else {
        return value;
      }
    },
  },

  components: {
    SiteButton,
    MenuItem,
    MenuItemScrolled,
    MenuItemMob,
  },

  created() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('load', this.handleResize);
    window.dispatchEvent(new Event('resize'));
    window.addEventListener('scroll', this.didScroll);
    this.handleResize();
  },

  destroyed() {
    window.removeEventListener('scroll', this.didScroll);
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    axios
      .get('/wp-json/wp/v2/menu')
      .then(response => (this.menu = response.data));
    axios
      .get('/wp-json/wp/v2/footer_menu')
      .then(response => (this.footerMenu = response.data));
    window.dispatchEvent(new Event('resize'));
    this.handleResize();
  },
  change() {
    window.dispatchEvent(new Event('resize'));
    this.handleResize();
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

header {
  // position: fixed;
  width: 100%;
  // top: 0;

  // body.logged-in & {
  // 	margin-top: 32px;

  // 	@media (max-width: 1100px) {
  // 		margin-top: 32px;
  // 	}

  // 	@media (max-width: 782px) {
  // 		margin-top: 46px;
  // 	}
  // }

  .menu {
    position: relative;
    z-index: 100;
    background: $cpmec-white;

    &.scrolled {
      position: fixed;
      top: 0;
      z-index: 900;
      width: 100%;
      background: $cpmec-grey;

      .logo {
        grid-column: span 1;
        display: flex;

        img {
          height: 40px;
          transition: 0.2s ease all;
          filter: grayscale(1);

          @media (max-width: $xl) {
            height: 30px;
          }

          // 	width: 265px;

          // @media (max-width: $xl) {
          // 	width: 250px;
          // }

          // @media (max-width: $md) {
          // 	width: 200px;
          // }

          // @media (max-width: $xs) {
          // 	width: 150px;
          // }
          // &:hover {
          // 	animation: rotate 3s linear infinite;
          // 	transition: 0.2s ease all;
          // }

          // @keyframes rotate {
          // 	to {
          // 		transform: rotate(360deg);
          // 	}
          // }
        }
      }

      .inner {
        padding: $spacer $spacer * 2;

        @media (max-width: $max-width-smaller) {
          padding: $spacer $spacer;
        }

        ul {
          li {
            a {
              color: $cpmec-white;

              &:hover {
                border-bottom: 2px solid $cpmec-white;
                transition: 0.2s ease all;
              }
            }
          }
        }

        .hamburger {
          @media (max-width: $xl) {
            grid-column: 2 / span 3;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-end;
            grid-template-columns: 1fr 1fr;
            column-gap: $spacer;
            align-items: center;

            &:hover {
              cursor: pointer;
            }

            .site_button {
              grid-column: 1 / span 1;
              width: auto;
            }

            svg {
              height: 40px;
              grid-column: 2 / span 1;

              path {
                fill: $cpmec-white;
                stroke: $cpmec-white;
              }
            }
          }

          @media (max-width: $xl) {
            .site_button {
              grid-column: 1 / span 1;
              width: auto;
              min-height: 50px;
              padding: 0 $spacer;
              column-gap: $spacer / 2;
            }
          }

          @media (max-width: $xs) {
            .site_button {
              grid-column: 1 / span 1;
              width: auto;
              min-height: 50px;
              padding: 0 $spacer / 2;
              column-gap: $spacer / 2;
            }
          }
        }
      }
    }

    .inner {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      column-gap: $spacer/2;
      max-width: $max-width;
      margin: 0 auto;
      padding: $spacer * 2 $spacer * 2;
      align-items: center;

      // @media (max-width: $max-width + 100px) {
      // 	max-width: 1630px;
      // 	padding: $spacer * 2 $spacer * 2;
      // }

      @media (max-width: $xl) {
        max-width: $max-width-smaller;
        margin: 0 auto;
        padding: $spacer $spacer;
      }
    }

    .logo {
      grid-column: span 1;
      display: flex;

      img {
        height: 40px;

        @media (max-width: $xl) {
          height: 30px;
        }

        // @media (max-width: $md) {
        // 	width: 200px;
        // }

        // @media (max-width: $xs) {
        // 	width: 150px;
        // }
      }
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: row;
      // column-gap: $spacer * 2;
      justify-content: flex-end;
      align-items: center;
      grid-column: span 3;

      > li {
        margin-right: $spacer * 2;

        &:last-of-type {
          margin-right: 0;
        }

        a {
          color: $cpmec-blue;
          text-decoration: none;
          font-weight: 400;
          transition: 0.2s ease all;
          border-bottom: 1px solid transparent;
          padding-bottom: 10px;
          margin-left: 0;

          &:hover {
            border-bottom: 2px solid $cpmec-blue;
            transition: 0.2s ease all;
          }
        }

        &.selected {
          a {
            border-bottom: 2px solid $cpmec-green;
            transition: 0.2s ease all;
          }
        }
      }

      > a {
        margin-left: $spacer * 2;
      }
    }

    .hamburger {
      @media (max-width: $xl) {
        grid-column: 2 / span 3;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        grid-template-columns: 1fr 1fr;
        column-gap: $spacer;
        align-items: center;

        &:hover {
          cursor: pointer;
        }

        .site_button {
          grid-column: 1 / span 1;
          width: auto;
        }

        svg {
          height: 40px;
          grid-column: 2 / span 1;

          path {
            fill: $cpmec-green;
            stroke: $cpmec-green;
          }
        }
      }
    }
  }

  .mobile-menu {
    background: $cpmec-blue;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 950;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media (max-width: $md) and (max-height: 900px) {
      overflow: scroll;
    }

    .inner {
      display: flex;
      // grid-template-columns: 1fr;
      // grid-template-rows: 30px auto auto auto;
      flex-direction: column;
      row-gap: $spacer * 5;
      margin: 0 $spacer 0 $spacer;
      padding: $spacer 0 $spacer 0;
      align-items: center;
      height: 100%;
      width: calc(100% - (40px * 2));
      justify-content: center;

      @media (max-width: $md) and (max-height: 900px) {
        row-gap: $spacer * 3;
        top: 30px;
        position: absolute;
      }

      @media (max-width: $xs) and (max-height: 600px) {
        row-gap: $spacer * 2;
      }

      .seg {
        display: grid;
        row-gap: $spacer * 3;
        grid-template-columns: 1fr;
        width: 100%;

        @media (max-width: $md) and (max-height: 900px) {
          row-gap: $spacer * 2;
        }

        @media (max-width: $xs) and (max-height: 600px) {
          row-gap: $spacer;
        }

        .site_button {
          width: auto;
        }
      }
    }

    .logo {
      grid-column: span 1;
      display: flex;
      justify-content: center;

      img {
        // width: 250px;
        height: 40px;

        @media (max-width: $xl) {
          // width: 200px;
          height: 30px;
        }
      }
    }

    .close {
      order: 2;
      appearance: none;
      position: absolute;
      top: 15px;
      right: 15px;

      &:hover {
        cursor: pointer;
      }

      body.logged-in & {
        margin-top: 32px;

        @media (max-width: $xl) {
          margin-top: 32px;
        }

        @media (max-width: $md) {
          margin-top: 46px;
        }
      }

      @media (max-width: $xl) {
        grid-column: 4 / span 1;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;

        svg {
          height: 40px;

          line {
            fill: $cpmec-green;
            stroke: $cpmec-green;
            stroke-width: 2px;
            stroke-linecap: round;
          }
        }
      }
    }

    ul {
      order: 3;
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      column-gap: $spacer * 2;
      justify-content: center;
      align-items: center;
      grid-column: span 2;
      row-gap: $spacer;

      @media (max-width: $xs) {
        row-gap: $spacer / 2;
      }

      &.footer-menu {
        column-gap: $spacer;
        row-gap: $spacer / 2;

        li {
          text-align: center;

          a {
            color: $cpmec-white;
            text-decoration: none;
            font-weight: normal;
            font-size: 18px;
          }
        }
      }

      &.social {
        display: inline-flex;
        flex-direction: row;
        padding: 0;
        margin: 0;

        li {
          a {
            display: flex;
          }
        }
      }

      li {
        display: block;
        width: 100%;

        a {
          color: $cpmec-green;
          text-decoration: none;
          font-weight: normal;
          font-size: 24px;
        }
      }
    }
  }

  .notification {
    position: relative;
    background: $cpmec-green;
    box-shadow: 0 0 10px -2px rgba(0, 0, 0, 0.25);
    z-index: 90;
    padding: 15px 0;

    &.scrolled {
      transform: translateY(-100px);
      transition: 0.2s ease all;
    }

    .inner {
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: $max-width;
      margin: 0 auto;

      span {
        font-family: $font-family;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
}

.rotate-fade-enter-active {
  animation: rotate-fade-in 0.25s;
}

.rotate-fade-leave-active {
  animation: rotate-fade-in 0.25s reverse;
}

@keyframes rotate-fade-in {
  0% {
    transform: rotate(0deg);
    opacity: 0;
  }
  100% {
    transform: rotate(180deg);
    opacity: 1;
  }
}

.slide-fade-enter-active {
  animation: slide-fade-in 0.25s;
}

.slide-fade-leave-active {
  animation: slide-fade-in 0.25s reverse;
}

@keyframes slide-fade-in {
  0% {
    transform: translateY(-100px);
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}

.mobile-menu-enter-active {
  animation: mobile-menu 0.25s;
}

.mobile-menu-leave-active {
  animation: mobile-menu 0.25s reverse;
}

@keyframes mobile-menu {
  0% {
    // transform: translateX(100%);
    opacity: 0;
  }
  100% {
    // transform: translateX(0%);
    opacity: 1;
  }
}

.bounce-enter-active {
  animation: bounce-in 0.15s;
}

.bounce-leave-active {
  animation: bounce-in 0.15s reverse;
}

@keyframes bounce-in {
  0% {
    transform: translateY(-100px);
    opacity: 0;
  }
  // 50% {
  // 	transform: translateY(30px);
  // 	opacity: 1;
  // }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SiteHeader.vue